/**
 * 接口地址
 */
const API = {
  api_root: process.env.API_ROOT,
  // 业务类
  // 登录页面
  login: {
    // login: () => `/system/authApi/login`,
    login: () => `/system/auth/login`,
    changePassword: () => `system/auth/changePassword`,
    // wxlogin: () => `/system/authApi/wxlogin`,
    wxlogin: () => `system/auth/login`,
    bindOpenid: () => `/system/authApi/bindOpenid`
  },
  // 主页
  home: {
    userInfo: () =>
      `system/auth/userInfo?roleId=${localStorage.getItem("roleId")}`,
    messageCount: () => `/system/auth/userInfo`,
    questionaireCount: () => `system/auth/questionaireCount`
  },
  //问卷
  questionnaire: {
    gradeAndCourse: classId =>
      `/info/api/courseAchieved/gradeAndCourse/${classId}`,
    // 获取二维码
    courseGoal: (courseId, classId) =>
      `/info/api/courseAchieved/courseGoal/${courseId}/${classId}`,
    //能力成长记录
    getAllGradeRef: () => `/info/api/courseAchieved/point/getAllGradeRef`,
    getByGraduationId: (pointId, grade, trem) =>
      `/info/api/courseAchieved/point/getByGraduationId/${pointId}/${grade}/${trem}`,
    getpoint: (graduationId, year, term) =>
      `/info/api/courseAchieved/point/getByGraduationId/${graduationId}/${year}/${term}`,
    listUnFinish: () => `/student/api/studentForm/list/0`,
    historyFinish: () => `/student/api/studentForm/list/1`,
    Business: () => `/form/rest/FormQuestionBaseBusiness/queryQuestionAll/v1`,
    AnswerAll: () =>
      `/form/rest/FormAnserBusiness/queryQuestionAndAnswerAll/v1`,

    earlyWarning: (versionId, year, term) =>
      `/info/api/courseAchieved/point/earlyWarning/${versionId}/${year}/${term}
      `
  },
  // 用户信息
  userInfo: {
    logout: () => `/system/auth/logout`
  },
  // 培养目标
  objectives: {
    objectives: () => `/info/information/getTrainTarget`
  },
  // 毕业要求
  graduationRequirements: {
    list: () => `/info/information/getGraduationClaim`
  },
  // 毕业要求指标点
  indicatorPoints: {
    list: () => `/info/information/getPointCourse`
  },
  // 课程体系
  courseSystem: {
    list: () => `/info/teacherinfo/getAllCourseByVersionId`
  },
  // 课程详情
  syllabus: {
    info: courseId =>
      `student/studentCourseControllerApi/studentcourse/${courseId}`
  },
  message: {
    list: () => ``
  }
};

export default API;
